const updateTeamSummaryMatchup = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const { liveData: { linescore: { teams = {}, currentInning, scheduledInnings, inningState } }, gameData: { datetime = {}, teams: { away = {}, home = {} }, status: { extendedStatus = {}, abstractGameState = '' } } } = action?.data ?? {};
            const {
                isPreGameDelay,
                isTBD,
                isWarmup,
                isSuspended,
                isInGameDelay,
                isInstantReplay,
                isManagerChallenge,
                isUmpireReview,
                isPostponed,
                isCancelled,
                isSuspendedResumptionOnDate
            } = extendedStatus;

            const gdata = {
                away,
                home,
                abstractGameState,
                currentInning,
                scheduledInnings,
                scores: {
                    away: teams.away?.runs,
                    home: teams.home?.runs
                },
                isPreGameDelay,
                isTBD,
                isWarmup,
                isSuspended,
                isInGameDelay,
                isInstantReplay,
                isManagerChallenge,
                isUmpireReview,
                isPostponed,
                isCancelled,
                isSuspendedResumptionOnDate,
                inningState,
                datetime
            };

            return { ...state, ...gdata };
        }

        if (datasource === 'standings') {
            const { standing } = action?.data?.standings || {};

            return { ...state, ...standing };
        }
    }

    return state;
};

export default updateTeamSummaryMatchup;
